import { Trash2 } from "lucide-react";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter,
  AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger,
} from "@/components/ui/alert-dialog";

export const ConfirmDelete = ({ title, text, onConfirm, testid, children, confirmLabel = "Supprimer" }) => (
  <AlertDialog>
    <AlertDialogTrigger asChild>
      {children || <button type="button" aria-label="Supprimer" data-testid={testid}><Trash2 className="h-4 w-4 text-muted-foreground transition-colors hover:text-destructive" /></button>}
    </AlertDialogTrigger>
    <AlertDialogContent data-testid="confirm-delete-dialog">
      <AlertDialogHeader>
        <AlertDialogTitle className="font-heading">{title}</AlertDialogTitle>
        <AlertDialogDescription>{text || "Cette action est définitive."}</AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter>
        <AlertDialogCancel className="rounded-full" data-testid="confirm-delete-cancel">Annuler</AlertDialogCancel>
        <AlertDialogAction className="rounded-full bg-destructive text-destructive-foreground hover:bg-destructive/90" onClick={onConfirm} data-testid="confirm-delete-confirm">{confirmLabel}</AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
);
